import { ApolloError } from '@apollo/client';
import { useAccommodationPropertyPhotosQuery } from '@graphql/generated';
import { addError } from '@shared/utils/logger';
import { useApiMetadata } from '@shared/hooks/useApiMetadata';

export const useAccommodationPlacePhotos = (joyPlaceIds: string[]) => {
  const { deviceType, anonymousId, eventId, userCountryCode } = useApiMetadata();

  const { data: accommodationPropertyPhotos, loading: loadingAccommodationPropertyPhotos } = useAccommodationPropertyPhotosQuery({
    variables: {
      payload: {
        propertyIdentifiers: joyPlaceIds?.map(id => ({ joyPlaceId: id })),
        metadata: {
          deviceType,
          anonymousId,
          eventId,
          userCountryCode,
        },
      },
    },
    onError(error: ApolloError) {
      addError(error, {
        source: 'Accommodation place photos api failed',
        context: 'searchAccommodationProperties',
        errorMessage: error.message,
        propertyIds: joyPlaceIds,
      });
    },
    skip: !joyPlaceIds?.length,
    batchMode: 'fast',
  });

  return { accommodationPropertyPhotos, loadingAccommodationPropertyPhotos };
};
